import './Tag.scss';

const Tag = ({
  label,
}) => (
  <div className="Tag">
    <span>{label}</span>
  </div>
);

export default Tag;
